import {Icon} from '@wandb/weave/components/Icon/Icon';
import {Pill} from '@wandb/weave/components/Tag';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import {Tooltip} from '@wandb/weave/components/Tooltip';
import React from 'react';

import {
  getDisplayNameForRegistryAccess,
  getIconForRegistryAccess,
} from '../common/permissionUtils';
import {globalRegistryType} from '../common/utils';

type RegistryDetailsReadOnlyProps = {
  registry: globalRegistryType;
};
export const RegistryDetailsReadOnly = ({
  registry,
}: RegistryDetailsReadOnlyProps) => {
  return (
    <Tailwind>
      <div className="my-24 flex w-full flex-col gap-12 rounded-lg border border-solid border-moon-250 bg-white px-32 py-24">
        <div className="flex w-full items-center justify-between">
          <div className="w-1/3 text-left text-base font-semibold leading-8 text-moon-450">
            Name
          </div>
          <div className="w-2/3 whitespace-normal break-all text-left text-base leading-8 text-moon-750">
            {registry.registryName}
          </div>
        </div>
        <div className="flex w-full items-center justify-between">
          <div className="w-1/3 text-left text-base font-semibold leading-8 text-moon-450">
            Visibility
          </div>
          <div className="flex w-2/3 flex-row items-center gap-8 text-moon-750">
            <Icon
              className="h-24 w-24"
              name={getIconForRegistryAccess(registry.access)}
            />
            <div className="whitespace-normal break-all text-left text-base leading-8">
              {getDisplayNameForRegistryAccess(registry.access)}
            </div>
          </div>
        </div>
        <div className="flex w-full items-center justify-between">
          <div className="w-1/3 text-left text-base font-semibold leading-8 text-moon-450">
            Owner
          </div>
          <div className="w-2/3 text-moon-750">
            <div className="flex items-center gap-8">
              <img
                src={registry.owner?.photoUrl ?? '/default-profile-picture.png'}
                className="h-24 w-24 rounded-full"
                alt=""
              />
              <div className="whitespace-normal break-all text-left text-base leading-8">
                {registry.owner?.name}
              </div>
            </div>
          </div>
        </div>
        <div className="flex w-full items-center justify-between">
          <div className="w-1/3 text-left text-base font-semibold leading-8 text-moon-450">
            Accepted artifact types
          </div>
          <div className="flex w-2/3 flex-row flex-wrap gap-8">
            {!registry.allowAllArtifactTypesInRegistry ? (
              registry.types?.map(type => {
                return (
                  <Tooltip
                    key={type}
                    trigger={
                      <div className="cursor-pointer">
                        <Pill color="moon" label={type} />
                      </div>
                    }
                    content={`Artifact type: ${type}`}
                    position="bottom left"
                  />
                );
              })
            ) : (
              <Pill color="moon" label={'All types'} />
            )}
          </div>
        </div>
        <div className="flex w-full items-center justify-between">
          <div className="w-1/3 text-left text-base font-semibold leading-8 text-moon-450">
            Description
          </div>
          <div className="w-2/3 whitespace-pre-line break-all text-left text-base leading-8 text-moon-750">
            {registry.description}
          </div>
        </div>
      </div>
    </Tailwind>
  );
};
